"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.watch = exports.registerInput = exports.AnimateVideoComponent = exports.AnimateHtmlComponent = void 0;
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2)
        for (var i = 0, l = from.length, ar; i < l; i++) {
            if (ar || !(i in from)) {
                if (!ar)
                    ar = Array.prototype.slice.call(from, 0, i);
                ar[i] = from[i];
            }
        }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var html_component_js_1 = require("./html-component.js");
Object.defineProperty(exports, "AnimateHtmlComponent", { enumerable: true, get: function () { return html_component_js_1.AnimateHtmlComponent; } });
var video_component_js_1 = require("./video-component.js");
Object.defineProperty(exports, "AnimateVideoComponent", { enumerable: true, get: function () { return video_component_js_1.AnimateVideoComponent; } });
var rm = {
    upgradeClip: function (mc, html, fn) { return html_component_js_1.AnimateHtmlComponent.upgrade(mc, html, fn); },
    addVideo: function (mc, videoSrc, bitmap) {
        return video_component_js_1.AnimateVideoComponent.upgrade(mc, videoSrc, bitmap);
    },
    registerInput: registerInput,
    values: new Map(),
    watch: watch,
    animate: this,
};
exports.default = rm;
function registerInput(name, mc, input) {
    console.log(name, mc, input);
}
exports.registerInput = registerInput;
var watcherMap = new WeakMap();
function watch(o, name, watcher, action) {
    var watched = [];
    if (watcherMap.has(o)) {
        watched = watcherMap.get(o);
        if (watched.includes(name))
            return;
    }
    watcherMap.set(o, __spreadArray(__spreadArray([], watched, true), [name], false));
    var lastValue = undefined;
    o.on("tick", function () {
        var v = watcher();
        if (v !== lastValue) {
            lastValue = v;
            action(v);
        }
    });
}
exports.watch = watch;
//# sourceMappingURL=index.js.map
//# sourceMappingURL=module.js.map